import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "../../common/mixins/permission";
import LineCreatePage from "./pages/LineCreatePage.vue";
import LineUpdatePage from "./pages/LineUpdatePage.vue";
import LineViewPage from "./pages/LineViewPage.vue";
import LineStopSyncViewPage from "./pages/LineStopSyncViewPage.vue";
import LineStopSyncCreatePage from "./pages/LineStopSyncCreatePage.vue";

export const LineRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "line"
) => [
  {
    name: "LineViewPage",
    path: prefix,
    component: LineViewPage,
    meta: { title: "Line List" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(PermissionName.LINE_VIEW)
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "LineCreatePage",
    path: `${prefix}/create`,
    component: LineCreatePage,
    meta: { title: "Create New Line" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(PermissionName.LINE_CREATE)
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "LineUpdatePage",
    path: `${prefix}/edit/:id`,
    component: LineUpdatePage,
    meta: { title: "Edit Line" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(PermissionName.LINE_UPDATE)
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "LineStopSyncViewPage",
    path: `${prefix}/stop-sync`,
    component: LineStopSyncViewPage,
    meta: { title: "Stop Sync Line" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.LINE_STOP_SYNC
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "LineStopSyncCreatePage",
    path: `${prefix}/stop-sync/create`,
    component: LineStopSyncCreatePage,
    meta: { title: "Create Stop Sync Line" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.LINE_STOP_SYNC
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
